import { Button, Collapse, Modal, Space, Spin, Tooltip, message } from "antd";
import { PlusIcon, EditIcon, TrashIcon } from "../../admin/Icons";
import { RedoOutlined, CopyOutlined } from '@ant-design/icons';
import Overlay from "../Overlay";
import wrap from "../../utils/wrap";
import Save from "../Save";
import StyleButton from "./StyleButton";
import { canDeleteRecord, deep, tt_button_delete, tt_button_duplicate, tt_button_edit, tt_button_reset } from "../../utils/Utils";
import { useState } from "react";
import { usePrefs } from "../../utils/Prefs";

export default function StyleButtons(props) {

    const { templates = [], data = {}, changed = false, view = "", setData = () => { } } = props;
    const [prefs, setPrefs] = usePrefs();

    // Used to temporarily undraw the UI so resetting sets the default values on uncontrolled UI
    const [hide, setHide] = useState(null);


    const default_button = {
        name: "Unnamed Button",
        init_font: 0,
        init_style: 1,
        init_size: 14,
        init_letter_spacing: 0,
        init_colour: 0,
        init_background_colour: 0,
        init_padding_x: 10,
        init_padding_y: 5,
        init_margin_x: 6,
        init_margin_y: 6,
        init_border_colour: 0,
        init_border_size: 0,
        init_border_radius: 0,
        init_drop_shadow_colour: 0,
        init_drop_shadow_x: 0,
        init_drop_shadow_y: 0,
        init_drop_shadow_blur: 0,
        init_drop_shadow_spread: 0,
        hover_style: 1,
        hover_colour: 0,
        hover_background_colour: 0,
        hover_border_colour: 0,
        hover_border_size: 0,
        hover_border_radius: 0,
        hover_drop_shadow_colour: 0,
        hover_drop_shadow_x: 0,
        hover_drop_shadow_y: 0,
        hover_drop_shadow_blur: 0,
        hover_drop_shadow_spread: 0
    }
    // Save name and default button object
    const saveNew = (_name, _obj) => {
        _obj.name = _name;
        _obj.id = data.buttons.length + 1;
        let _buttons = [...data.buttons];
        _buttons.push(_obj);
        setData({ ...data, "buttons": _buttons });
        setPrefs({ ...prefs, "changed": true, "button_index": _obj.id });
    }

    // Save a field in a button (deep object save)
    const save = (_id, _value, _keys = [], _new = false) => {
        let _buttons = [...data.buttons];
        let _index = _buttons.findIndex(item => item.id === _id)
        // instance found
        if (_index > -1) {
            _buttons[_index][_keys[0]] = _value;
            setData({ ...data, "buttons": _buttons });
            setPrefs({ ...prefs, "changed": true })
        }
    }


    const remove = (e, _id) => {
        e.stopPropagation();
        e.preventDefault();
        Modal.confirm({
            title: "Delete?",
            onOk: () => {
                let _buttons = data.buttons.filter(item => item.id !== _id);
                setData({ ...data, "buttons": _buttons });
                setPrefs({ ...prefs, "changed": true });
            }
        })
    }


    // Remove Button
    const reset = (e, _id) => {
        e.stopPropagation();
        e.preventDefault();
        Modal.confirm({
            title: "Reset?",
            onOk: () => {
                setHide(_id);
                let _buttons = [...data.buttons];
                let _f = _buttons.findIndex(item => item.id === _id)
                if (_f > -1) {
                    _buttons[_f] = { ...default_button, "id": _id }
                } else {
                    message.error("There was an error");
                }
                setData({ ...data, "buttons": _buttons });
                setPrefs({ ...prefs, "changed": true });
                setTimeout(() => {
                    setHide(null)
                }, 100)
            }
        })
    }

    const duplicate = (e, _obj) => {
        e.stopPropagation();
        e.preventDefault();
        Modal.confirm({
            title: "Duplicate?",
            onOk: () => {
                _obj.name = _obj.name + " (copy)";
                _obj.id = data.buttons.length + 1;
                let _buttons = [...data.buttons];
                _buttons.push(_obj);
                setData({ ...data, "buttons": _buttons });
                setPrefs({ ...prefs, "changed": true, "button_index": _obj.id });
            }
        })
    }

    // Draw header
    const drawHeader = () => {
        return (
            <Overlay width="320px" component={<StyleButton default_button={default_button} saveNew={saveNew} save={save} is_new buttons={data.buttons} />}><wrap.tags color="#1890ff"><PlusIcon />&nbsp;<small>New</small></wrap.tags></Overlay>
        )
    }

    // Draw button list
    const drawButtons = () => {
        return (
            <div>
                <Collapse accordion onChange={(e) => setPrefs({ ...prefs, "button_index": e })} activeKey={prefs.button_index} className="subpanel" expandIcon={({ isActive }) => {
                    return (isActive) ? "-" : "+"
                }} ghost>
                    {data.buttons.map(item => {

                        if (hide === item.id) {
                            return (<></>)
                        }
                        let name = (item.hasOwnProperty("name")) ? item.name : ""
                        let can_delete = canDeleteRecord(templates, data, item.id, "buttons", "Unnamed Button");
                        return (
                            <Collapse.Panel header={
                                <div className="float-flex">
                                    <div style={{ "color": "#e77e21", "fontSize": "11px" }}>{name.toUpperCase()}</div>
                                    <Space size={0}>
                                        <Tooltip title={tt_button_duplicate}><Button onClick={(e) => duplicate(e, { ...item })} type="link" icon={<CopyOutlined />} size="small" /></Tooltip>
                                        {(!can_delete && <Tooltip title={tt_button_delete}><Button onClick={(e) => reset(e, item.id)} type="link" icon={<RedoOutlined />} size="small" /></Tooltip>)}
                                        {(can_delete && <Tooltip title={tt_button_reset}><Button onClick={(e) => remove(e, item.id)} type="link" icon={<TrashIcon />} size="small" /></Tooltip>)}
                                        <Overlay width="320px" component={<StyleButton default_button={default_button} saveNew={saveNew} save={save} is_edit id={item.id} button={item} buttons={data.buttons} />}>
                                            <Tooltip title={tt_button_edit}><Button type="link" icon={<EditIcon />} size="small" /></Tooltip>
                                        </Overlay>
                                    </Space>
                                </div>

                            } key={item.id}>
                                <StyleButton default_button={default_button} saveNew={saveNew} save={save} data={data} button={item} buttons={data.buttons} />
                            </Collapse.Panel>
                        )
                    })}
                </Collapse>
                {/* <small><pre>{JSON.stringify(data.buttons, null, 2)}</pre></small> */}
            </div>
        )
    }

    switch (view) {
        case "header":
            return drawHeader();
        default:
            return drawButtons();
    }

}

